import * as request from 'services/request'

/**
 * Fetches a widget's moderation filter lists from the live
 * `widget_data.blacklistConfig` store.
 *
 * @param {string} widgetId Widget ID
 * @returns {Promise<{words: string[], handles: string[], allowWords: string[]}>} Filter lists
 */
export const getWidgetFilters = async widgetId => {
  const response = await request.authorized(`/filters/widget/${widgetId}`)
  return response.json()
}

/**
 * Persists a widget's moderation filter lists onto the live
 * `widget_data.blacklistConfig` store.
 *
 * @param {string} widgetId Widget ID
 * @param {object} lists The filter arrays
 * @param {string[]} [lists.words] Deny words
 * @param {string[]} [lists.handles] Deny @handles
 * @param {string[]} [lists.allowWords] Allow words
 * @returns {Promise<Response>} The fetch response
 */
export const updateWidgetFilters = async (widgetId, lists) =>
  request.authorized(`/filters/widget/${widgetId}`, {
    method: 'PUT',
    body: lists
  })

export default {
  getWidgetFilters,
  updateWidgetFilters
}



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-filtering/filter-requests.js